import { render, staticRenderFns } from "./NormalSearchNav482.vue?vue&type=template&id=0c05e50a&scoped=true&"
import script from "./NormalSearchNav482.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav482.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05e50a",
  null
  
)

export default component.exports